import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageHeader';
import Linkedin from '../../assets/img/logo/linkedin-logo.svg';
import UpIcon from '../../assets/img/icon/up-icon.svg';
import CloseIcon from '../../assets/img/icon/close.svg';
import Style from './style.module.scss';

const Contact = () => {
  const { t } = useTranslation();
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <SEO pageKey="contact" />
      <PageHeader title={t('contactTitle')} />
      <section className={Style.section}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2>{t('contactPage.title')}</h2>
            <div className={Style.contactItem}>
              <h4>{t('contactPage.address')}</h4>
              <p>{t('contactPage.companyAddress')}</p>
              <div>
                <img className={Style.upIcon} src={UpIcon} alt="show-on-map-icon" />
                <a
                  href="https://maps.app.goo.gl/D8Ai7BZgYwH5omV86"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('contactPage.showOnMap')}
                </a>
              </div>
            </div>
            <div className={Style.contactItem}>
              <h4>{t('contactPage.phone')}</h4>
              <p>{t('phoneNumber')}</p>
            </div>
            <div className={Style.contactItem}>
              <h4>{t('contactPage.email')}</h4>
              <h3>{t('contactPage.generalContact')}</h3>
              <p>info@ngaming.com</p>
              <h3>{t('contactPage.careerJobApplication')}</h3>
              <p>kariyer@ngaming.com</p>
            </div>
            <div>
              <img className={Style.upIcon} src={UpIcon} alt="show-on-map-icon" />
              <button onClick={openModal}>{t('contactPage.contactDetail')}</button>
            </div>
            <div className={Style.contactLinkedin}>
              <a
                href="https://www.linkedin.com/company/ngaming/jobs/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Linkedin} alt="nGaming-Linkedin-logo" />
              </a>
            </div>
          </div>
          <div className={Style.imgWrapper}>
            <img src={'./assets/img/contact.png'} alt="contact" />
          </div>
        </div>
      </section>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Contact Detail"
        className={Style.contactDetail}
        overlayClassName={Style.overlay}
        ariaHideApp={false}
      >
        <div className={Style.popupHeader}>
          <h4>{t('contactPage.contactDetail')}</h4>
          <button className={Style.closeHeader} onClick={closeModal}>
            <img src={CloseIcon} alt="close" />
          </button>
        </div>
        <div className={Style.popupContent}>
          <div className={Style.contentItem}>
            <span>{t('contactPage.companyName')}</span>
            <p>D Yazılım Teknoloji A.Ş.</p>
          </div>
          <div className={Style.contentItem}>
            <span>{t('contactPage.tradeRegistryNumber')}</span>
            <p>1013742</p>
          </div>
          <div className={Style.contentItem}>
            <span>{t('contactPage.email')}</span>
            <a href="mailto:info@ngaming.com">info@ngaming.com</a>
          </div>
          <div className={Style.contentItem}>
            <span>{t('contactPage.kepAddress')}</span>
            <a href="mailto:dsans@hs02.kep.tr">dsans@hs02.kep.tr</a>
          </div>
          <div className={Style.contentItem}>
            <span>{t('contactPage.mersisNo')}</span>
            <p>0843086767600001</p>
          </div>
        </div>
        <div className={Style.popupFooter}>
          <button className={Style.closeBtn} onClick={closeModal}>
            {t('contactPage.close')}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Contact;
